import { render, staticRenderFns } from "./config-dialog.vue?vue&type=template&id=2ae7b54e&"
import script from "./config-dialog.vue?vue&type=script&lang=js&"
export * from "./config-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports